import { isChunkLoadError } from '@/utils/chunk-load-error';
import { isAbortError } from '@/utils/abort-error';
import { isCognitoNetworkError } from '@/services/api/cognito';

const getEventMessage = (event, error) => (
  error?.message
  || event?.message
  || event?.exception?.values?.[0]?.value
  || ''
);

export const shouldIgnoreSentryError = (event, hint) => {
  const error = hint?.originalException;

  if (isAbortError(error)) return true;
  if (isChunkLoadError(error)) return true;
  if (isCognitoNetworkError(error)) return true;

  const message = getEventMessage(event, error);
  if (/aborted|AbortError/i.test(message)) return true;
  if (isChunkLoadError({ message })) return true;
  if (message === 'Network error') return true;
  if (message.includes("reading 'hasOwnProperty'")) return true;

  return false;
};
